import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Skeleton, Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../contexts/UserContext';
import { useDispatch, useSelector } from "react-redux";
import { FETCH_COLOR_LIST, FETCH_PRODUCT_LIST, FETCH_SPACE_LIST, FETCH_TOTAL_COUNT_LIST } from "../../redux/actions";
import ColorSelectSearch from "./ColorSelectSearch";
import SpaceSelectSearch from "./SpaceSelectSearch";
import { clearSearchInputContent, setSearchInputContent } from "../../redux/slices/searchInputSlice";
import { clearColor } from "../../redux/slices/selectColor";
import { clearSpace } from "../../redux/slices/selectSpace";

const MainSearch = () => {
    const { t } = useTranslation();

    const loading = useSelector((state) => state.loading);



    const dispatch = useDispatch();
    const { colorData } = useSelector((state) => state.colorData);
    const { spaceData } = useSelector((state) => state.spaceData);
    // const { totalCountData } = useSelector((state) => state.totalCountData);
    const searchInputContent = useSelector((state) => state.searchInputContent.searchInputContent);
    const totalCount = useSelector((state) => state.totalCount);

    const { userConfigs } = useUser();


    const handleInputChange = (e) => {
        dispatch(setSearchInputContent(e.target.value));
    };

    const handleClearFilters = () => {
        dispatch(clearSearchInputContent());
        dispatch(clearColor())
        dispatch(clearSpace())
        dispatch({ type: FETCH_PRODUCT_LIST });
    };


    useEffect(() => {
        dispatch({ type: FETCH_SPACE_LIST });
        dispatch({ type: FETCH_COLOR_LIST });
        dispatch({ type: FETCH_TOTAL_COUNT_LIST });
    }, []);




    return (

        <Row>
            <Col className="search" xs={24} sm={24} md={16} lg={16}>
                <>
                    <Col span={24} style={{ marginBottom: 15 }}>
                        <Input size="large"
                            className='search-input'
                            placeholder={t('search.search_assets')}
                            value={searchInputContent}
                            onChange={handleInputChange}
                            prefix={<span className={userConfigs.dark ? 'search-icon' : 'search-light-icon'} />} />
                    </Col>

                    <Row gutter={8} align="middle">
                        <Col span={24} xs={12} sm={9}>
                            <ColorSelectSearch options={colorData} defaultValue={t('search.color')} />
                        </Col>
                        <Col span={24} xs={12} sm={9}>
                            <SpaceSelectSearch options={spaceData} defaultValue={t('search.space')} />
                        </Col>
                        <Col span={24} xs={24} sm={6} className='clear-filter-main-search'>
                            <Button style={{ width: '100%' }}
                                size="middle" className="clear-filter" onClick={handleClearFilters}>
                                {t('search.clear_filter')}
                            </Button>
                        </Col>
                    </Row>

                </>
            </Col>

            <Col className='assets-box' xs={24} sm={24} md={7} lg={7} offset={1}>
                <span className='count'>{totalCount}</span>
                <span className='title'>{t('search.assets')}</span>
            </Col>

        </Row>
    );
};

export default MainSearch;
